(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["protocol-hero-block"] && !Shopify.designMode) return;
  try {
    const bgPositionMap = {
    'top-left': '0% 0%',
    'top-center': '50% 0%',
    'top-right': '100% 0%',
    'center-left': '0% 50%',
    'center': '50% 50%',
    'center-right': '100% 50%',
    'bottom-left': '0% 100%',
    'bottom-center': '50% 100%',
    'bottom-right': '100% 100%'
  };
  const bgPosition = '{{ block.settings.background_position | default: "center" }}';
  document.querySelector('#{{ panel_id }} .protocol-pairing__card').style.setProperty('--bg-position', bgPositionMap[bgPosition] || '50% 50%');
  } catch(e) { console.error(e); }
})();

})();
